var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop } from 'vue-property-decorator';
import { OutsourceCollectionService } from "~/services/domain-service/outsource-collection-manage.service";
import { FilterService } from "~/utils/filter.service";
var LeaveCase = /** @class */ (function (_super) {
    __extends(LeaveCase, _super);
    function LeaveCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.leaveCaseModel = {
            leaveDueDate: '',
            leaveCaseFlagExplain: '',
            caseIds: []
        };
        //表单
        _this.form = {};
        return _this;
    }
    LeaveCase.prototype.refresh = function () {
        //   重置form表单xr
        var addForm = this.$refs['form'];
        addForm.resetFields();
        this.leaveCaseModel = {};
    };
    LeaveCase.prototype.refreshList = function () {
    };
    LeaveCase.prototype.close = function () {
        this.refresh();
    };
    LeaveCase.prototype.mounted = function () {
    };
    LeaveCase.prototype.commit = function () {
        var _this = this;
        this.form = this.$refs['form'];
        this.form.validate(function (valid) {
            if (!valid) {
                return;
            }
            _this.leaveCaseModel.caseIds = [];
            _this.selectionList.forEach(function (element) {
                _this.leaveCaseModel.caseIds.push(element.id);
            });
            _this.leaveCaseModel.leaveDueDate = FilterService.dateEndFormat(_this.leaveCaseModel.leaveDueDate);
            _this.outsourceCollectionService.caseStay(_this.leaveCaseModel).subscribe(function (data) {
                _this.$message.success("留案成功!");
                _this.refreshList();
                _this.close();
                _this.refresh();
            });
        });
    };
    __decorate([
        Dependencies(OutsourceCollectionService)
    ], LeaveCase.prototype, "outsourceCollectionService", void 0);
    __decorate([
        Prop()
    ], LeaveCase.prototype, "selectionList", void 0);
    __decorate([
        Emit('refreshList')
    ], LeaveCase.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], LeaveCase.prototype, "close", null);
    LeaveCase = __decorate([
        Component({
            components: {},
        })
    ], LeaveCase);
    return LeaveCase;
}(Vue));
export default LeaveCase;
